import styled from '@emotion/styled';
import { Button, H1SectionTitle, SideLayoutContentWrapper } from '@presentation/components';
import { css } from '@emotion/react';
import { mediaQuery } from '@presentation/styles';

export const CoverImage = styled.div<{ src: string }>`
  background: url(${(props) => props.src}) no-repeat center center;
  background-size: cover;
  height: 400px;
  width: 100%;
  ${mediaQuery('tablet')} {
    height: 300px;
  }
  ${mediaQuery('small')} {
    height: 250px;
  }
`;

export const DefaultContent = styled.div`
  b,
  strong {
    font-weight: bold;
  }

  a {
    color: ${(props) => props.theme.color.blue.default};
    padding-bottom: 1px;

    &:hover {
      cursor: pointer;

      padding-bottom: 0px;
      border-bottom: 1px solid ${(props) => props.theme.color.blue.default};
    }
  }

  ul {
    list-style: circle !important;
  }

  ol {
    list-style: decimal !important;
  }

  ul,
  ol {
    margin-bottom: 20px;
    padding-left: 25px;

    li {
      padding-left: 8px;
      margin-bottom: 5px;
    }
  }

  * {
    font-family: ${(props) => props.theme.font.default} !important;
  }
`;
export const VerticalMargin = styled.div`
  margin-top: 50px;
  margin-bottom: 50px;
`;

export const SideContentWrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
  background: ${(props) => props.theme.color.light.default};
  overflow: hidden;
  max-width: 600px;
  margin: au ul {
    list-style: circle !important;
  }to;
`;

export const SideButtonContainer = styled.div`
  padding: 15px;
`;

export const SideButton = styled(Button)`
  margin-bottom: 10px;
`;

export const InfoTitle = styled.div`
  padding: 20px 15px;
  padding-bottom: 5px;
  color: ${(props) => props.theme.color.blue.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  font-size: 22px;
  text-transform: uppercase;
`;

export const InfoAttributeWrapper = styled.div`
  display: flex;
  padding: 7px 15px;
  align-items: center;
`;

export const InfoAttributeLabel = styled.div`
  font-weight: 500;
  width: 60%;
`;

export const Main = styled.div`
  flex: 1;
  padding: 50px;
`;

export const MainImage = styled.img`
  object-fit: cover;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
`;

export const ImageWrapperContainer = styled.div`
  /* height: 200px; */
  width: 100%;
  padding-top: 75%; /* 4:3 Aspect Ratio (divide 3 by 4 = 0.75) */
  position: relative;
`;

export const ImageWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const SectionWrapperLitters = styled.div`
  background: ${(props) => props.theme.color.blue.light};
  margin: 100px 0;
  position: relative;
  padding-bottom: 10px;
`;

export const SectionWrapperBreeders = styled.div`
  margin-bottom: 100px;
  padding: 30px 0;
`;

export const SectionTitle = styled.div<{ color: 'blue' | 'light' }>`
  color: ${(props) => props.theme.color[props.color].default};
  font-family: ${(props) => props.theme.font.alternate};
  padding: 25px 0;
`;

export const Title = styled(H1SectionTitle)`
  margin-bottom: 0;
`;

export const TitleSubscribeWrapperMobile = styled.div`
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${mediaQuery('medium', 'min')} {
    display: none;
  }
`;

export const TitleSubscribeWrapperDesktop = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  ${mediaQuery('medium')} {
    display: none;
  }
`;

export const BannerWrapper = styled.div`
  margin-top: 25px;
`;

export const StyledSideLayoutContentWrapper = styled(SideLayoutContentWrapper)<{ hasBg?: boolean }>`
  padding-left: 50px;
  padding-right: 0px;

  ${(props) =>
    props.hasBg &&
    `
  ${mediaQuery('medium', 'min')} {
    margin-top: 80px;
  }

  ${mediaQuery('medium')} {
    margin-top: 25px;
  }
  
  `}
`;

export const SideBannerWrapper = styled.div`
  margin-top: 24px;
  margin-left: auto;
  margin-right: auto;
`;

export const SideGeneticsTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${(props) => props.theme.color.blue.default};
`;

export const SideGeneticsSubtitle = styled.div`
  margin-top: 24px;
  font-weight: 500;
  margin-left: 15px;
`;

export const SideGeneticsList = styled.ul``;

export const SideGeneticsItem = styled.li`
  font-size: 14px;
  margin-top: 20px;
  margin-left: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SideGeneticsTextWrapper = styled.div`
  flex: 1;
`;

export const SideGeneticsIconWrapper = styled.div`
  border-radius: 50%;
  background-color: ${(props) => props.theme.color.blue.default};
  color: ${(props) => props.theme.color.light.default};
  width: 36px;
  height: 36px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SideGeneticsInfoBox = styled.div`
  background-color: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  padding: 16px;
  border-radius: 8px;
`;

export const SideGeneticsInfoBoxTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
  display: flex;
  gap: 4px;
  align-items: center;

  svg {
    font-size: 26px;
  }
`;

export const SideGeneticsInfoBoxText = styled.div`
  margin-top: 8px;
  font-weight: 500;
  font-size: 14px;
`;

export const PageHeader = styled.h1`
  ${SectionTitle}
`;

export const SideGeneticsWrapper = styled.div`
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  padding: 16px;
  margin-top: 30px;
`;
